import { NgModule } from 'ng-metadata/core';
import {PrmPersonEntityPage} from "./personEntityPage.directive";
import {PersonEntityPageService} from "./personEntityPage.service";

const angularDeckgrid = require('angular-deckgrid');

@NgModule({
    declarations: [
        PrmPersonEntityPage
    ],
    providers: [
        PersonEntityPageService
    ],
    imports:[
        'akoenig.deckgrid'
    ]
})
export class PersonEntityPageModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/personEntityPage/personEntityPage.module.ts